import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { find } from 'lodash'
import { RootState } from '../../../store'
import ImageProperties from './ImageProperties'
import TextProperties from './TextProperties'
import BarcodeProperties from './BarcodeProperties'
import LineProperties from './LineProperties'
import CircleProperties from './CircleProperties'
import RectProperties from './RectProperties'
import EllipseProperties from './EllipseProperties'
import WedgeProperties from './WedgeProperties'
import RingProperties from './RingProperties'
import ArcProperties from './ArcProperties'
import ArrowProperties from './ArrowProperties'

interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class ElementProperties extends Component<CombinedProps> {
  render () {
    const { selectedElement } = this.props
    if (!selectedElement) return null
    switch (selectedElement.type) {
      case 'image':
        return <ImageProperties selectedElement={selectedElement} />
      case 'text':
        return <TextProperties selectedElement={selectedElement} />
      case 'barcode':
        return <BarcodeProperties selectedElement={selectedElement} />
      case 'line':
        return <LineProperties selectedElement={selectedElement} />
      case 'circle':
        return <CircleProperties selectedElement={selectedElement} />
      case 'rect':
        return <RectProperties selectedElement={selectedElement} />
      case 'ellipse':
        return <EllipseProperties selectedElement={selectedElement} />
      case 'wedge':
        return <WedgeProperties selectedElement={selectedElement} />
      case 'ring':
        return <RingProperties selectedElement={selectedElement} />
      case 'arc':
        return <ArcProperties selectedElement={selectedElement} />
      case 'arrow':
        return <ArrowProperties selectedElement={selectedElement} />
      default:
        return null
    }
  }
}

function mapStateTopProps (state: RootState, props: Props) {
  const { labelBuilder } = produce(state, draft => draft)
  const { elements } = labelBuilder.markup
  const selectedElement = find(elements, element => {
    return element.id === labelBuilder.markup.selectedElement
  })
  return { selectedElement }
}

const mapDispatchToProps = {}

const connector = connect(mapStateTopProps, mapDispatchToProps)
export default connector(ElementProperties)
